import { c as _c } from "react/compiler-runtime";
import { Banner } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import useHostedMachine from 'src/hooks/use-hosted-machine';
const SandboxBanner = () => {
  const $ = _c(5);
  const {
    t
  } = useTranslation("common");
  const [state] = useHostedMachine();
  const {
    onboardingConfig
  } = state.context;
  const isSandbox = onboardingConfig?.isLive === false;
  let t0;
  if ($[0] !== isSandbox || $[1] !== t) {
    t0 = isSandbox && <Banner variant="warning">{t(_temp)}</Banner>;
    $[0] = isSandbox;
    $[1] = t;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== t0) {
    t1 = <div className="hidden md:block! border-b border-tertiary">{t0}</div>;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
export default SandboxBanner;
function _temp($) {
  return $.components.layout.sandboxBanner;
}